
import { Component, Vue } from 'vue-property-decorator';
import OsParticipantOverview from '@/components/shared/participants/OsParticipantOverview.vue';
import userModule from '@/store/UserModule';
import { customersApi } from '@/apis';
import { ITargetProfile } from '@/models/application';
import OsTargetProfileOverview from '@/components/shared/target-profiles/OsTargetProfileOverview.vue';
@Component({
  components: { OsTargetProfileOverview, OsParticipantOverview }
})
export default class CampaignTargetProfilesIndex extends Vue {
  customerId!: string;
  campaignId!: string;
  targetProfiles: ITargetProfile[] = [];

  async created() {
    this.customerId = userModule.state.customer!.id;
    this.campaignId = this.$route.params.campaignid;
    this.targetProfiles = await customersApi.getTargetProfiles(
      this.customerId,
      this.campaignId
    );
  }

  rowClicked(selected: any) {
    this.$router.push(
      `/campaigns/${this.campaignId}/target-profiles/${selected.id}`
    );
  }
}
